var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlashCircle01 = function SvgSlashCircle01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d2f99c74-9442-4528-b7c0-c6ccb55f346fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5484D",
    fillRule: "evenodd",
    d: "M3.312 4.255a6 6 0 0 0 8.433 8.433zm.943-.943 8.433 8.433a6 6 0 0 0-8.433-8.433M.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d2f99c74-9442-4528-b7c0-c6ccb55f346fa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSlashCircle01;